import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=5817a6c1&scoped=true&"
import script from "./OrdersFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFilters.vue?vue&type=style&index=0&id=5817a6c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817a6c1",
  null
  
)

export default component.exports